import React, { useState, useEffect } from 'react'
import tw, { css } from 'twin.macro'
import './style.css'

export const AccordionIndex = ({
	items,
	backGroundColor,
	activeBackGroundColor,
	withIndex = false,
	related = false,
	setActiveTab = () => {},
	activeTab = '',
}) => {
	const [isExpanded, setIsExpanded] = useState({})

	const toggleExpand = (index, reviseIndex) => {
		setIsExpanded(prevState => {
			const newState = related
				? { [index]: !prevState[index] }
				: { [index]: !prevState[index] }
			if (related) {
				setActiveTab(reviseIndex.toString())
			}
			return newState
		})
	}

	useEffect(() => {
		if (related && activeTab) {
			const toExpand = items.find(
				item => item.reviseIndex === (Number(activeTab) - 1).toString()
			)
			if (toExpand) {
				const toExpandIndex = items.indexOf(toExpand)
				setIsExpanded({ [toExpandIndex]: true })
			} else {
				setIsExpanded({})
			}
		}
	}, [activeTab, related, items])
	return (
		<>
			<ul css={tw`flex flex-col px-1 space-y-2 md:space-y-1 w-full`}>
				{items.map((item, index) => (
					<li
						key={index}
						className={`${
							isExpanded[index] ? activeBackGroundColor : backGroundColor
						}`}
						css={tw`flex flex-col space-y-3 px-4 md:px-7 text-xs`}
					>
						<p css={tw`flex items-center font-bold pt-3 pb-0 md:pt-4 md:pb-1`}>
							<span
								css={tw`p-2 rounded-full font-extrabold mr-6 text-xl cursor-pointer text-center`}
								className={`${
									isExpanded[index] ? backGroundColor : activeBackGroundColor
								}`}
								onClick={() =>
									toggleExpand(index, Number(item.reviseIndex) + 1)
								}
							>
								{isExpanded[index] ? (
									<svg
										xmlns="http://www.w3.org/2000/svg"
										fill="none"
										viewBox="0 0 24 24"
										stroke="white"
										css={tw`rounded-full h-5 w-5 cursor-pointer`}
									>
										<path
											strokeLinecap="round"
											strokeLinejoin="round"
											strokeWidth={3}
											d="M6 12h12"
										/>
									</svg>
								) : withIndex ? (
									<span tw="h-5 w-5 text-gray-700 text-base flex items-center justify-center">
										<span>
											{item.reviseIndex
												? Number(item.reviseIndex) + 1
												: index + 1}
										</span>
									</span>
								) : (
									<svg
										xmlns="http://www.w3.org/2000/svg"
										fill="none"
										viewBox="0 0 24 24"
										stroke="#58C8DF"
										css={tw`rounded-full h-5 w-5 cursor-pointer`}
									>
										<path
											strokeLinecap="round"
											strokeLinejoin="round"
											strokeWidth={3}
											d="M12 6v6m0 0v6m0-6h6m-6 0H6"
										/>
									</svg>
								)}
							</span>
							<span
								css={tw`text-sm`}
								className={`${isExpanded[index] ? 'text-black' : 'text-white'}`}
							>
								{item.title}
							</span>
						</p>
						<div
							style={{
								maxHeight: isExpanded[index] ? '1000px' : '0',
								transition: 'max-height 0.3s ease-in-out',
								overflow: 'hidden',
							}}
						>
							<p css={tw`pb-5 text-sm text-black`}>{item.content}</p>
						</div>
					</li>
				))}
			</ul>
		</>
	)
}
